export enum PanoramaTransactions {
  serviceListControllerInitialization = 'service-list-controller-initialization',
  serviceListServicesQuery = 'service-list-services-query',
  serviceListCategoriesQuery = 'service-list-categories-query',
  serviceListLocationsQuery = 'service-list-locations-query',
  serviceListBookingsSettingsFetch = 'service-list-bookings-settings-fetch',
  serviceListAvailabilityEnrichment = 'service-list-services-availability-enrichment',
  serviceListClassesDaysEnrichment = 'service-list-classes-offered-days-enrichment',
  serviceListFilterOptionsHydration = 'service-list-filter-options-hydration',
  serviceListFilterInteraction = 'service-list-filter-interaction',
  serviceListPaginationInteraction = 'service-list-pagination-interaction',
}
